// Sitewide dashboard announcement API methods — mixin applied to the
// ApiService prototype chain. Methods run with `this` bound to the
// ApiService instance, so this.request() resolves through the shared
// HttpClient base.
const withAnnouncementsApi = (Base) => class extends Base {
  /** Any signed-in user: the active announcement (if any) plus whether they've dismissed it. */
  async getActiveAnnouncement() {
    return this.request('/announcements/active');
  }

  /** Admin-only: the raw current state (even if inactive), for the management panel. */
  async getAdminAnnouncement() {
    return this.request('/announcements/admin');
  }

  /** Admin-only: post a new announcement, replacing whatever was active before. */
  async postAnnouncement(message) {
    return this.request('/announcements', {
      method: 'POST',
      body: JSON.stringify({ message }),
    });
  }

  /** Admin-only: manually take down the active announcement. */
  async deactivateAnnouncement() {
    return this.request('/announcements/deactivate', { method: 'POST' });
  }

  /** Dismiss the current version for the signed-in user only. */
  async dismissAnnouncement(version) {
    return this.request('/announcements/dismiss', {
      method: 'POST',
      body: JSON.stringify({ version }),
    });
  }
};

export default withAnnouncementsApi;
